// extracted by mini-css-extract-plugin
module.exports = {"container":"h2","containerExpand":"h3","headerRow":"h4","headerCol":"h5","image":"h6","title":"h7","date":"h8","dateExpand":"h9"};